const TagDataReference = `
  fragment TagDataReference on TagDataReference {
    label
    value
  }
`
export default TagDataReference
